import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { BackgroundResponse } from 'components/BackgroundComponent/types';
import { PersonsResponse } from 'components/PersonComponent/types';
import { RootState } from '../store';

export interface ResourcesState {
  bgLoaded: boolean;
  bgLoading: boolean;
  personsLoaded: boolean;
  personsLoading: boolean;
  bgList: BackgroundResponse[];
  personList: PersonsResponse[];
}

const initialState: ResourcesState = {
  bgLoaded: false,
  bgLoading: true,
  personsLoaded: false,
  personsLoading: true,
  bgList: [],
  personList: [],
};

export const loadBackgrounds = createAsyncThunk('resources/loadBackgrounds', async () => {
  if (window.novellStory && window.novellStory.bg) {
    if (typeof window.novellStory.bg === 'string') {
      const res = await fetch(window.novellStory.bg);
      if (res.status !== 200) {
        throw new Error();
      }
      const BG = (await res.json()) as BackgroundResponse[];
      return BG;
    }
    return window.novellStory.bg;
  }
  throw new Error();
});

export const loadPersons = createAsyncThunk('resources/loadPersons', async () => {
  if (window.novellStory && window.novellStory.person) {
    if (typeof window.novellStory.person === 'string') {
      const res = await fetch(window.novellStory.person);
      if (res.status !== 200) {
        throw new Error();
      }
      const PERSONS = (await res.json()) as PersonsResponse[];

      return PERSONS;
    }
    return window.novellStory.person;
  }
  throw new Error();
});

export const resourcesSlice = createSlice({
  name: 'resources',
  initialState,
  extraReducers: {
    [loadBackgrounds.pending.type]: (state) => {
      state.bgLoading = true;
    },
    [loadBackgrounds.rejected.type]: (state) => {
      state.bgLoaded = false;
      state.bgLoading = false;
    },
    [loadBackgrounds.fulfilled.type]: (state, action) => {
      state.bgList = action.payload;
      state.bgLoading = false;
      state.bgLoaded = true;
    },
    [loadPersons.rejected.type]: (state) => {
      state.personsLoaded = false;
      state.personsLoading = false;
    },
    [loadPersons.pending.type]: (state) => {
      state.personsLoading = true;
    },
    [loadPersons.fulfilled.type]: (state, action) => {
      state.personList = action.payload;
      state.personsLoading = false;
      state.personsLoaded = true;
    },
  },
  reducers: {
    setBGLoaded: (state, action: PayloadAction<boolean>) => {
      state.bgLoaded = action.payload;
    },
    setPersonsLoaded: (state, action: PayloadAction<boolean>) => {
      state.personsLoaded = action.payload;
    },
  },
});

export const { setBGLoaded, setPersonsLoaded } = resourcesSlice.actions;

export const getBGLoaded = (state: RootState) => state.resources.bgLoaded;
export const getBGLoading = (state: RootState) => state.resources.bgLoading;
export const getBGList = (state: RootState) => state.resources.bgList;
export const getPersonsLoaded = (state: RootState) => state.resources.personsLoaded;
export const getPersonsLoading = (state: RootState) => state.resources.personsLoading;
export const getPersonsList = (state: RootState) => state.resources.personList;

export const resourcesReducer = resourcesSlice.reducer;
